<app-dialog-header title="Filter Certification Dates" (onClick)="dialogRef.close(false)"></app-dialog-header>
<div mat-dialog-content class="p-24" [formGroup]="dateFilterForm">
    <div fxLayout="column" fxLayoutAlign="space-between center">
        <div class="p-24 mb-8 w-100-p bg-lightgreybackground" fxLayout="column" fxLayoutAlign="space-between flex-start">
            <label class="mb-8">{{ 'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_ISSUED_AFTER' | translate }}</label>
            <mat-form-field class="w-100-p">
                <input
                    matInput
                    name="after"
                    formControlName="after"
                    [matDatepicker]="issuedAfterPicker"
                    placeholder="Select date"
                    readonly
                    inputmode="none"
                    (click)="issuedAfterPicker.open()"
                    (focus)="issuedAfterPicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="issuedAfterPicker"></mat-datepicker-toggle>
                <mat-datepicker #issuedAfterPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="p-24 w-100-p bg-lightgreybackground" fxLayout="column" fxLayoutAlign="space-between flex-start">
            <label class="mb-8">{{ 'PAGE.CERTIFICATIONS.LABEL.SHOW_CERTIFICATES_ISSUED_BEFORE' | translate }}</label>
            <mat-form-field class="w-100-p">
                <input
                    matInput
                    name="before"
                    formControlName="before"
                    [matDatepicker]="issuedBeforePicker"
                    placeholder="Select date"
                    readonly
                    inputmode="none"
                    (click)="issuedBeforePicker.open()"
                    (focus)="issuedBeforePicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="issuedBeforePicker"></mat-datepicker-toggle>
                <mat-datepicker #issuedBeforePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayoutAlign="flex-end center">
    <app-white-button class="mr-8" label="Cancel" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button label="Save" (onClick)="onSave()" [disabled]="!dateFilterForm.dirty || !dateFilterForm.valid"></app-flat-button>
</div>
